import { render, staticRenderFns } from "./multiselect-filter.vue?vue&type=template&id=22c815f8"
import script from "./multiselect-filter.vue?vue&type=script&lang=ts"
export * from "./multiselect-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports